exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-dialog--center .el-dialog__body {\n    text-align: initial;\n    padding: 25px 27px 0px;\n}\n.set-ibox{\n    margin-bottom:0;\n}\n.el-form-item {\n    margin-bottom: 16px;\n}\n.set-ibox-content {\n    padding: 5px 20px 8px 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-811fe15a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/childmgr/childsmgrAdd.vue
// module id = EBHm
// module chunks = 4